import { MemberType } from './../../shared/enums/data.enums';
import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Observable, of, forkJoin } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, share } from "rxjs/operators";
import { Router } from "@angular/router";

import {
	GlobalDomOpsService,
	CommonOperationsService,
	GlobalDataOpsService,
	AcepSSOService
} from "@acepteam/globalspack";
import {
	DomService,
	DataService,
	HelperService,
	LoggerService
} from "../../core/services";
import { MemberAppDomService } from "./member-app-dom.service";
import { MyAccountDataOpsService } from "./my-account-dataops.service";

import { environment } from "../../../environments/environment";
import {
	AppUiData,
	MemberAppData,
	MembershipDetails,
	EducationDetails,
	CRMMembership
} from "../../shared/models";
import {
	MapMemberAppData,
	MapChapterDetails,
	MapSectionDetails,
	MapMembershipDetails,
	CheckIfInternational,
	CheckIfUSOrCanada,

} from "../helpers/mapper";
import { MyAccountDetails } from "../../shared/models/my-account-data.models";
import { NotificationStatus } from "../../shared/enums/data.enums";
import { MembershipOrganization, MembershipRate } from "../../shared/enums/xrm.constants";

declare var $: any;
declare var moment: any;

@Injectable({
	providedIn: "root"
})
export class MemberAppDataService {
	public memberAppData: MemberAppData;
	private _myAccountData: MyAccountDetails;
	isAGraduatingResident = false;
	isAGraduatingFellow = false;
	membTypeSavedFromUI: MemberType = null;
	isActiveMemberOrUnderReinstatement = false;

	//Local Storage keys
	private MEMBERSHIPDETAILS_KEY: string = "MEMBERSHIPDETAILS";


	constructor(
		private ssoService: AcepSSOService,
		private globalDomOpsService: GlobalDomOpsService,
		private memberAppDomService: MemberAppDomService,
		private domService: DomService,
		private globalDataOpsService: GlobalDataOpsService,
		private dataService: DataService,
		private myAccountDataService: MyAccountDataOpsService,
		private commonOpsService: CommonOperationsService,
		private helperService: HelperService,
		private titleService: Title,
		private loggerService: LoggerService,
		private http: HttpClient,
		private router: Router
	) { }

	GetMemberAppData(): Observable<MemberAppData> | Observable<any> | any {

		//console.log("data service calling MyAccount stats.");
		if (this.memberAppData) {
			return of(this.memberAppData);
		}

		// let memberAppData$: Observable<MemberAppData> | any = this.http.post(this.dataService.dashboardapiendpoint + 'GetDashboardDetailsForContact', JSON.stringify({ 'contactid': this.ssoService.contactid })).pipe(map((res: Response) => this.processMemberAppData(res)), share());

		let obs1: Observable<any> = this.http.post(
			this.dataService.memberappapiendpoint +
			"GetMembershipDetailsForContact",
			JSON.stringify({ contactid: this.ssoService.contactid })
		);

		// let obs1: Observable<any> = this.http.post(this.dataService.dashboardapiendpoint + 'GetDashboardDetailsForContact', JSON.stringify({ 'contactid': this.ssoService.contactid }));

		let obs2: Observable<any> = this.http.post(
			this.dataService.memberappapiendpoint + "LoadMembership",
			JSON.stringify({ contactid: this.ssoService.contactid, issectionapp: this.dataService.IsSectionApplication })
		);

		let memberAppData$: Observable<MemberAppData | any> | any = forkJoin(
			obs1,
			obs2
		).pipe(
			map((res: any) => {
				this.processMemberAppData(res);
			}),
			share()
		);

		return memberAppData$;
	}

	LoadMembership() {

		let obs2: Observable<any> = this.http
			.post(
				this.dataService.memberappapiendpoint + "LoadMembership",
				JSON.stringify({ contactid: this.ssoService.contactid, issectionapp: this.dataService.IsSectionApplication })
			)
			.pipe(
				map((res: any) => {
					this.processLoadMembershipDetails(res);
				})
			);

		return obs2;
	}

	UpdateRetiredFlag(retiredFlag: boolean) {
		let obs2: Observable<any> = this.http
			.post(
				this.dataService.memberappapiendpoint + "UpdateContactRetired",
				JSON.stringify({ contactid: this.ssoService.contactid, isretired: retiredFlag })
			);

		return obs2;
	}

	UpdateOptOutRegYR123Flag(optedOut: boolean) {
		let obs: Observable<any> = this.http
			.post(
				this.dataService.memberappapiendpoint + "UpdateContactOptOutRegYR123",
				JSON.stringify({ contactid: this.ssoService.contactid, optout: optedOut })
			);

		return obs;
	}


	processMemberAppData(response) {
		let json_myaccdata = response[0];
		let json_load_membership_data = response[1];

		this._myAccountData = this.myAccountDataService.MapMyAccountData(
			json_myaccdata
		);

		this.processLoadMembershipDetails(json_load_membership_data);

		this.CheckApplicationStatus(this.memberAppData);

		return this.memberAppData;
	}

	processLoadMembershipDetails(json_load_membership_data: any) {
		//update isacepmember is ssosvc. this is used in checkapplicationstatus method 

		let m = json_load_membership_data.Table.find(a => a.OrganizationCode == 1);
		if (m != null && !this.ssoService.isacepmember) {
			let today = moment();
			let paidthroughdate = moment(m.PaidThroughDate);
			let numberofmonthsSinceExpirationDate = today.diff(
				paidthroughdate,
				"months",
				true
			);

			if (numberofmonthsSinceExpirationDate <= 0) {
				this.ssoService.isacepmember = true;
			}

		}




		this.memberAppData = MapMemberAppData(
			this.myAccountDataService.myaccountdata,
			json_load_membership_data,
			this.memberAppData
		);

		//************MEMBERSHIP TYPE - START**************//
		this.memberAppData.membershipDetails = MapMembershipDetails(
			this.myAccountDataService.myaccountdata,
			this.memberAppData
		);

		//Read from session storage
		let mdSessionStorage: MembershipDetails = this.GetMembershipInSessionStorage();
		if (mdSessionStorage) {
			// this.memberAppData.membershipDetails.activeMilitary =
			// 	mdSessionStorage.activeMilitary;
			this.memberAppData.membershipDetails.emResidencyTrained =
				mdSessionStorage.emResidencyTrained;
		}
		//************MEMBERSHIP TYPE - END**************//

		//MEDICAL LICENSES
		this.memberAppData.medicalLicences = this._myAccountData.credentials.medicallicenses;


		//CHAPTERS
		this.memberAppData.chapterDetails = MapChapterDetails(
			this.memberAppData
		);

		//SECTIONS
		this.memberAppData.sectionDetails = MapSectionDetails(
			this.memberAppData
		);



		//Check If Progression Passed/Failed
	}

	SaveMembershipInSessionStorage(membership: MembershipDetails): void {
		this.dataService.SaveInLocalStorage(
			this.MEMBERSHIPDETAILS_KEY,
			JSON.stringify(membership)
		);
	}

	GetMembershipInSessionStorage(): MembershipDetails {
		let s: string = this.dataService.GetFromLocalStorage(
			this.MEMBERSHIPDETAILS_KEY
		);
		let md: MembershipDetails = JSON.parse(s);
		return md;
	}

	ResetMemberAppData() {
		this.memberAppData = null;
		this.globalDomOpsService.showwait();
	}

	notify(status: NotificationStatus) {
		this.memberAppData.notifyInfo.status = status;
		//this.navigateToRoute("notify");
		this.router.navigate(["notify"], {
			replaceUrl: true
		});
	}

	navigateToRoute(routename) {
		this.router.navigate([routename]);
	}

	getContentSnippet(key: string): string {
		let cs = this.memberAppData
			? this.memberAppData.ContentSnippets.find(a => a.key == key)
			: null;
		let csVal: string = cs ? cs.value : "";
		return csVal;
	}

	cancelStaleOrders() {
		//get the orders marked as expired from teh sproc
		let payload = this.memberAppData.profile.orders;
		//.filter(function (s) { return s.isexpired === 1 });
		let orderids = payload.map(o => o.orderid).join(",");
		if (orderids == "") return of([]); //Create an empty observable
		let jpayload = {
			orderids: orderids,
			contactid: this.ssoService.contactid
		};
		return this.http.post(
			this.dataService.memberappapiendpoint.replace(
				"acepmemberappapi",
				"sempamemberappapi"
			) + "CancelStaleOrders",
			jpayload
		);
	}

	SetInternational() {
		this.memberAppData.profile.IsInternational = CheckIfInternational(
			this.memberAppData.addresses
		);
	}

	//pga:coding-5865 method to update flag for US or Canada
	SetUSOrCanada() {
		this.memberAppData.profile.IsUSOrCanada = CheckIfUSOrCanada(
			this.memberAppData.addresses
		);
	}

	CheckApplicationStatus(memberappData: MemberAppData) {
		let MONTHS_RENEWAL = 2;
		let MONTHS_REINSTATEMENT = 6;
		let MONTHS_GRACE = -12;

		let routename = "notify";

		this.isActiveMemberOrUnderReinstatement = this.ssoService.isacepmember;

		//bypass if retired or SectionApp
		if (this.dataService.IsRetirementApplication || this.dataService.IsSectionApplication) return;

		let m: CRMMembership = memberappData.profile.membership;

		if (!m) {
			m = new CRMMembership();
		}
		//Get orders and cancel the stale orders//
		this.cancelStaleOrders()
			.subscribe(() => {
				this.loggerService.logInfo("Cancelled Stale Orders");
			})
			.unsubscribe();
		console.info("Expiration Date", m.ExpirationDate);

		//IF NEW APPLICATION / PROGRESSION DID NOT SUCCEED.. RETURN THE USER BACK
		if (!m.ProgressionSuccessFul) {
			this.loggerService.logError(
				"Progression Failed. Take he user back to the first page"
			);
		}
		if (!m.ExpirationDate || !m.ProgressionSuccessFul) return;

		let dtformat = "MM/DD/YYYY";
		let today = moment(); //moment('5/1/2016'); ////now
		let currentExpDate = moment(m.ExpirationDate);
		if (!!m.CancellationDate && !this.isActiveMemberOrUnderReinstatement) {
			currentExpDate = moment(m.CancellationDate);
		}

		this.memberAppData.notifyInfo.expirationdate = currentExpDate.format(
			dtformat
		);

		let numberofmonthsSinceExpirationDate = today.diff(
			currentExpDate,
			"months",
			true
		);


		let readyForRenewalDate = currentExpDate.add(
			MONTHS_GRACE,
			"M"
		);


		console.info(
			"readyForRenewalDate",
			readyForRenewalDate.format(dtformat)
		);

		let navigateTo = false;
		let updateToMembershipRecord = false;

		//FIRST CHECK FOR AUTORENEWAL//
		if (m.IsOnAutoRenewal) {
			navigateTo = true;
			console.log("AUTO RENEWAL IS ON");
			this.memberAppData.notifyInfo.status =
				NotificationStatus.AutoRenewalActive;
		} else {
			//you have to consider the diff function like a minus operator.
			if (today.diff(readyForRenewalDate) > 0) {
				//READY FOR RENEWAL//
				console.log("READY FOR RENEWAL");

				if (numberofmonthsSinceExpirationDate <= MONTHS_RENEWAL) {
					//REGULAR RENEWAL
				} else if (
					numberofmonthsSinceExpirationDate > MONTHS_RENEWAL &&
					numberofmonthsSinceExpirationDate <= MONTHS_REINSTATEMENT
				) {
					//REINSTATEMENT
					this.isActiveMemberOrUnderReinstatement = true;
					console.log("CURRENTLY IN REINSTATEMENT PERIOD");
				} else if (
					numberofmonthsSinceExpirationDate > MONTHS_REINSTATEMENT
				) {
					//RESTART - if more than 6 months past expiration date
					console.log("CURRENTLY IN RESTART PERIOD");
					this.memberAppData.notifyInfo.status =
						NotificationStatus.ReadyToRestart;
				}
				navigateTo = true;
				//pga: coding-4915 Changed the logic to open the section for renewing member
				//Now the personal info will open by default while renewing
				routename = "personal";
			} else {
				//NOT READY FOR RENEWAL -- Take them to notify page and display message//
				navigateTo = true;
				//routename = 'checkout';
				console.log("NOT READY FOR RENEWAL YET");
				this.memberAppData.notifyInfo.status =
					NotificationStatus.NotReadyForRenewal;
			}
		}


		//For RegYR123
		if (
			numberofmonthsSinceExpirationDate > MONTHS_RENEWAL &&
			numberofmonthsSinceExpirationDate <= MONTHS_REINSTATEMENT
			&& !this.isActiveMemberOrUnderReinstatement
		) {
			//REINSTATEMENT
			console.log("CURRENTLY IN REINSTATEMENT PERIOD");
			this.isActiveMemberOrUnderReinstatement = true;

		}

		//Check for Odd cases where a person is on installments or auto renewals and the credit card has expired in between and  did not respond to MCC  to update his payment information

		if (m.IsOnAutoRenewal || m.IsOnInstallments) {
			navigateTo = true;
			let paidthroughdate = moment(m.PaidThroughDate);
			//if paid through date is in the past ..he has to call MCC
			if (today.diff(paidthroughdate, "days") > 0) {
				this.memberAppData.notifyInfo.status = NotificationStatus.Error;
				this.loggerService.logError(
					"Paid through date is in the Past. Member did not pay since long time and probably did not update his credt card info"
				);
			}
		}

		//Take emra residents under renewal and graduating this year to first tab..and default member type to physicians so they can continue as emra fellow or em physician(active year1)https://jira.acep.org/browse/EM-482 MB 3/4/2020
		this.isAGraduatingResident = this.CheckIfGraduatingResdientUnderRenewal();
		this.isAGraduatingFellow = this.CheckIfGraduatingFellowUnderRenewal();
		let isCandidate = this.CheckIfMedicalStudentOrResident();

		if (this.isAGraduatingResident || this.isAGraduatingFellow) {
			this.memberAppData.membershipDetails.memberType = MemberType.Physician;
			navigateTo = true;
			routename = "personal";

		}


		if (navigateTo) {
			this.router.navigate([routename], { replaceUrl: true });
		}
	}



	CheckIfEligibleForRegYR123(): boolean {


		let _isRegYr123 = this.memberAppData.profile.IsRegYR123;
		return _isRegYr123;

		// let isAResdientOrPhy = (this.memberAppData.membershipDetails.memberType == MemberType.Resident || this.memberAppData.membershipDetails.memberType == MemberType.Physician);
		// let isGraduationThisYear = false;
		// if (this.memberAppData.educationDetails.residency && (moment(this.memberAppData.educationDetails.residency.graduationdate).year() == moment().year())) {
		// 	isGraduationThisYear = true;
		// }

		// let isAFormerMember = this.isActiveMemberOrUnderReinstatement;

		// let isFellow = (this.memberAppData.profile.membership != null) &&
		// 	((this.memberAppData.profile.membership?.FutureMemberRate == MembershipRate.Fellow) ||
		// 		(this.memberAppData.profile.membership?.FutureMemberRate == MembershipRate.CnFellw) ||
		// 		(this.memberAppData.profile.membership?.FutureMemberRate == MembershipRate.IntFellw));


		// if (isAResdientOrPhy && isGraduationThisYear && isAFormerMember && !isFellow) {
		// 	return true;
		// }



		// return false;

	}

	CheckIfGraduatingResdient(): boolean {

		let isAResdient = (this.memberAppData.membershipDetails.memberType == MemberType.Resident);
		let isGraduationThisYear = false;
		if (this.memberAppData.educationDetails.residency && (moment(this.memberAppData.educationDetails.residency.graduationdate).year() == moment().year())) {
			isGraduationThisYear = true;
		}

		if (isAResdient && isGraduationThisYear) {
			return true;
		}

		return false;

	}

	CheckIfGraduatingResdientUnderRenewal(): boolean {

		let isAGraduatingRes = this.CheckIfGraduatingResdient();
		let isAFormerMember = this.ssoService.isacepmember;

		return isAGraduatingRes && isAFormerMember;

	}

	CheckIfGraduatingFellowUnderRenewal(): boolean {


		let isAFellow = (this.memberAppData.membershipDetails.memberType == MemberType.Fellow);
		let isAFormerMember = this.ssoService.isacepmember;
		let isGraduationThisYear = false;

		if (this.memberAppData.educationDetails.fellowship && (moment(this.memberAppData.educationDetails.fellowship.graduationdate).year() == moment().year())) {
			isGraduationThisYear = true;
		}

		if (isAFellow && isAFormerMember && isGraduationThisYear) {
			return true;
		}

		return false;


	}

	CheckIfMedicalStudentOrResident(): boolean {
		return (this.memberAppData.membershipDetails.memberType == MemberType.Student || this.memberAppData.membershipDetails.memberType == MemberType.Resident);
	}

	CheckIfCandidateMemberType(): boolean {
		return (this.memberAppData.membershipDetails.memberType == MemberType.Student
			|| this.memberAppData.membershipDetails.memberType == MemberType.Resident
			|| this.memberAppData.membershipDetails.memberType == MemberType.Fellow);
	}
}
